import React from 'react'
import { useTranslation } from 'react-i18next';
import Images from '../../assets/images';
import './Club.css';
import { Box, Button, Grid } from '@mui/material';

const Club = () => {
  const { t } = useTranslation();

  return (
    <div className='club' id='club' style={{ scrollMarginTop: 'clamp(96px, 10vw, 212px)' }}>
      <Grid container className='body' justifyContent={'center'} alignContent={'center'}>
        <Grid container item xs={12} md={5} className='left' >
          <label className='mobile'>{t(`club.label`)}</label>
          <h1 className='mobile'>{t(`club.title`)}<span>{t(`club.title2`)}</span></h1>
          <img className='image1' src={Images.tiim.club} alt='club' />
          <Box>
            <h2>{t(`club.benefits`)}</h2>
            {
              t(`club.benefitsList`).map((item, index) => (
                <Grid key={index} container flexDirection={'row'} gap={2} >
                  <img className='check' src={Images.icons.circleCheck2} alt={'check'} />
                  <h4>{item}</h4>
                </Grid>
              ))
            }
          </Box>
        </Grid>
        <Grid container item xs={12} md={7} className='right' >
          <label className='desktop'>{t(`club.label`)}</label>
          <h1 className='desktop'>{t(`club.title`)}<span>{t(`club.title2`)}</span></h1>
          <img className='image2' src={Images.tiim.club2} alt='club' />
          <h3>{t(`club.subtitle`)}</h3>
          <pre>{t(`club.description`)}</pre>
          <Button className='button' variant="contained" onClick={() => window.location.href = "mailto:hello@tiimschool.com"}>
            {t(`club.button`)}
          </Button>
        </Grid>
        <Grid className='tournamentLeft' container item justifyContent={'center'} alignContent={'center'} >
          <img className='tournament' src={Images.tiim.club3} alt='payment' />
        </Grid>
        <Grid className='tournamentRight' container item justifyContent={'center'} alignContent={'center'} flexDirection={'column'} >
          <p className='title'>{t(`club.tournament`)}<p className='title2'>{t(`club.tournament2`)}</p></p>
          <p className='description'>{t(`club.tournamentDescription`)}</p>
          <Button className='tournamentButton' variant="contained" onClick={() => window.location.href = "mailto:hello@tiimschool.com"}>
            {t(`club.tournamentButton`)}
          </Button>
        </Grid>
      </Grid>
    </div>

  )
}

export default Club 